import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActionPanelModule } from '@components/action-panel';
import { FeatureAnalyticsApiService } from '@core/analytics';
import { ApplicationController } from '@core/application';
import { AuthInterceptor } from '@core/authentication';
import { GlobalDataService } from '@core/global-data';
import { HttpApiService } from '@core/http';
import { DictionaryService } from '@core/i18n';
import { ReferentialsController } from '@core/referentials';
import {
  ActionService,
  AppConfigService,
  DateService,
  NavigationService
} from '@core/services';
import { UserController } from '@core/user';
import { provideTranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { PageModule } from '@shared/containers/page';
import { TranslatorService } from '@shared/services';
import { ShellController } from '@shell/services';
import { ToastMessage, ToastMessageService } from '@widgets/toast-message';
import { QuillModule } from 'ngx-quill';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

export function configInit(config: AppConfigService) {
  return () => config.load();
}
export function dictionaryInit(dictionary: DictionaryService) {
  return () => dictionary.load();
}

export function AppDataInit(service: GlobalDataService) {
  try {
    return () => service.init();
  }
  catch (e) {
    return e;
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    QuillModule.forRoot(),
    ActionPanelModule,
    PageModule,
    AppRoutingModule,
    ToastMessage,
  ],
  providers: [
    provideTranslateService(),
    AppConfigService,
    FeatureAnalyticsApiService,
    provideAppInitializer(() => {
      const initializerFn = (configInit)(inject(AppConfigService));
      return initializerFn();
    }),
    GlobalDataService,
    provideAppInitializer(() => {
      const initializerFn = (AppDataInit)(inject(GlobalDataService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = (dictionaryInit)(inject(DictionaryService));
      return initializerFn();
    }),
    AuthInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    ActionService,
    ApplicationController,
    DateService,
    HttpApiService,
    NavigationService,
    ReferentialsController,
    ShellController,
    TranslatorService,
    UserController,
    ToastMessageService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { enterAnimationDuration: '0ms', exitAnimationDuration: '0ms' } }
  ]
})

export class AppModule { }
